import React, { useEffect, useState } from "react";
import { gettext } from "web/script/modules/django-i18n";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import classnames from "classnames";
import globals from "web/script/modules/globals";
import browser from "web/script/utils/browser";
import analytics from "web/script/analytics/analytics";
import _throttle from "lodash/throttle";
import styles from "./scroll-to-top-button.css";

function ScrollToTopButton(): JSX.Element {
    const [isVisible, setIsVisible] = useState(false);

    function onClick(event): void {
        event.preventDefault();
        setIsVisible(false);
        analytics.event("NAVIGATION", "SCROLL_TO_TOP", "button");
        browser.scrollTop(0);
    }

    useEffect(() => {
        function onScroll(): void {
            const isBannerVisible = globals.window.pageYOffset > browser.getWindowHeight() * 1.5;

            setIsVisible(isBannerVisible);
        }

        const throttledOnScroll = _throttle(onScroll, 100);

        globals.window.addEventListener("scroll", throttledOnScroll);
        return (): void => {
            globals.window.removeEventListener("scroll", throttledOnScroll);
        };
    }, []);

    return (
        <button
            className={classnames(styles.wrapper, {
                [styles.wrapperShow]: isVisible,
            })}
            onClick={onClick}
        >
            <SVGIcon name={"chevron"} className={styles.svgIcon} />
            <p className={styles.text}>{gettext("feeds.scroll_to_top_btn_text")}</p>
        </button>
    );
}

export default ScrollToTopButton;
